import React, {Fragment, PureComponent} from 'react';
import Image from 'app/helpers/Image';

const FieldName = ({value}) => {
    switch (value) {
    case 'dota':
        return <Fragment>Dota 2 Skin</Fragment>;
    case 'cs':
        return <Fragment>CS:GO Skin</Fragment>;
    case 'artifact':
        return <Fragment>EGB Skin</Fragment>;
    case 'money':
        return <Fragment>Money</Fragment>;
    default:
        return null;
    }
};

export default class ChooseField extends PureComponent {
    handleChoosing = e => {
        e && e.preventDefault();

        const {chooseSkin, value} = this.props;
        return chooseSkin(value, e);
    };

    render() {
        const {skin_gift_images, value} = this.props;
        return (
            <div className="gift-choose-wrapper" id={`skin-${value}`}>
                <input
                    type="radio"
                    name="game-choice"
                    className="field__invisible"
                    onClick={this.handleChoosing}
                />
                <div className="gift-choose__content">
                    <div className={`gift-choose__icon ${value}`}>
                        <Image
                            image={{
                                name: value,
                                url: skin_gift_images[value]
                            }}
                        />
                    </div>
                    <div className="gift-choose__name">
                        <FieldName {...this.props}/>
                    </div>
                </div>
            </div>
        );
    }
}
